import React from "react";
import pixelGif from "../../assets/gifs/pixel-hero-cape-new.gif"
import "../../assets/css/loading/Loading.css"

const PixelEdumanLoader = ({isAbsolute, isFixed, isSticky, message, time}) => {
    return(
        <>
            <div className={"flex flexCenter loadingElBackground" + (isAbsolute ? " positionAbsolute" : "") + (isFixed ? " positionFixed" : "") + (isSticky ? " positionSticky" : "")}>
                <img alt="Pixelated Eduman loading screen." className={"loadingGif"} src={pixelGif}></img>
                {/* <div className="inverseCornerLeft" />
                <div className="inverseCornerRight" /> */}
            </div>
            <div className={"textAlignCenter loadingMessage" + (isAbsolute ? " positionAbsolute" : "") + (isFixed ? " positionFixed" : "") + (isSticky ? " positionSticky" : "")}>
                {message && message}
                <br />
                {time && "~"+time+" seconds"}
            </div>
        </>
    )
}

export default PixelEdumanLoader;